import PlatformActions from './PlatformActions'

export default class FCSLOTActions extends PlatformActions {
  constructor(formData) {
    super(formData)
    this.formData = formData

    this.constantTxnData = {
      gameType: 'SLOT',
      gameName: 'RICH MAN',
      gameCode: 'FC-SLOT-018',
      platform: 'FC',
    }
  }

  getBetNSettleMessage(txnList) {
    const { currency, supportPremium } = this.formData

    const txns = txnList.map(({
      userId,
      txnId,
      roundId,
      betTime,
      betAmount,
      turnover,
      winAmount,
      updateTime,
      jackpotWinAmount,
    }) => ({
      ...this.constantTxnData,
      userId,
      platformTxId: `${txnId}`, // 4663241255
      roundId: `${roundId}`, // 6871603023
      betType: null,
      currency,
      betTime, // 2021-10-01T14:09:37.000+08:00
      txTime: betTime,
      betAmount, // betAmount.toFixed(1)
      turnover,
      winAmount,
      jackpotBetAmount: 0,
      jackpotWinAmount: jackpotWinAmount ?? 0,
      updateTime,
      requireAmount: betAmount,
      ...(supportPremium && { isPremium: false }),
    }))

    const message = {
      action: 'betNSettle',
      txns,
    }

    return JSON.stringify(message)
  }

  getCancelBetNSettleMessage(txnList) {
    const txns = txnList.map(({
      userId,
      txnId,
      roundId,
      betAmount,
      updateTime,
    }) => ({
      ...this.constantTxnData,
      userId,
      platformTxId: `${txnId}`,
      roundId: `${roundId}`,
      updateTime,
      betAmount,
    }))

    const message = {
      action: 'cancelBetNSettle',
      txns,
    }

    return JSON.stringify(message)
  }

  getGiveMessage(txnList) {
    const { currency } = this.formData

    const txns = txnList.map(({
      userId,
      betAmount,
      promotionTxId,
      txTime,
    }) => ({
      platform: this.constantTxnData.platform,
      currency,
      userId,
      amount: betAmount,
      promotionTxId: `${promotionTxId}`, // 67f8bf16b69c5d6757cf8bff
      promotionId: '1322',
      promotionTypeId: '0',
      txTime, // 2025-04-11T15:06:39.000+08:00
    }))

    const message = {
      action: 'give',
      txns,
    }

    return JSON.stringify(message)
  }
}
